import { render, staticRenderFns } from "./growupStep.vue?vue&type=template&id=33944733&scoped=true&"
import script from "./growupStep.vue?vue&type=script&lang=js&"
export * from "./growupStep.vue?vue&type=script&lang=js&"
import style0 from "./growupStep.vue?vue&type=style&index=0&id=33944733&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33944733",
  null
  
)

export default component.exports